import { Show } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import React from 'react';
import { PersonDto } from 'types/personen';
import { useTranslation } from 'utils/hooks';

interface StammdatenProps 
{
  person: PersonDto;
}

const Stammdaten: React.FC<StammdatenProps> = (props) => 
{
  const { person } = props;
  const isPlusPage = person.tier === 'Plus';
  const { t } = useTranslation('profiles');

  return (
    <>

      {/* Name */}
      <ContentRow id="allgemeines" title={t('profiles:personen.name.label')} groupItem>
        {person.hauptPersonenDaten.fullName}
      </ContentRow>

      {/* Andere Namen */}
      <Show when={person.personenDaten.length > 1}>
        <ContentRow title={t('profiles:personen.otherNames.label')} groupItem>
          {
            <ul className="contentList">{
              [...person.personenDaten]
                .filter(pd => pd.fullName !== person.hauptPersonenDaten.fullName)
                .map(pd => (<li key={pd.fullName}>{pd.fullName}</li>))
            }</ul>
          }
        </ContentRow>
      </Show>

      {/* Geburtsdatum */}
      <Show when={isPlusPage}>
        <ContentRow title={t('profiles:personen.birthdate.label')}>
          {person.hauptPersonenDaten.geburtsdatum ? t('formats:date', { value: person.hauptPersonenDaten.geburtsdatum }) : t('common:profiles.noBirthdate')}
        </ContentRow>
      </Show>

    </>
  );
};

export default Stammdaten;
